<mat-chip-list selectable [multiple]="multiple">
  <mat-chip
    #chip="matChip"
    *ngFor="let option of displayOptions"
    [value]="option.value"
    (click)="toggleSelection(chip)"
    [class]="'no-select' + (chip.selected ? ' active' : '')"
  >
    {{ option.text | translate }}
  </mat-chip>
</mat-chip-list>

<!-- Other -->
<div class="other-input" *ngIf="showOtherInput" [@fadeInAndOut]>
  <mat-form-field appearance="fill">
    <input
      matInput
      type="text"
      [(ngModel)]="otherInputValue"
      (keyup.enter)="saveOtherValue()"
      (blur)="saveOtherValue()"
      placeholder="{{ 'form.other.placeholder' | translate }}"
      #otherInput
    />
  </mat-form-field>
</div>
